import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { UserInfo } from '@/api/codegen'
import { CLOUD_WORKER_ROLE_NAME } from '@/constants/roles.constants'

const USER_STORE_KEY = 'auth-user-store'

interface AuthUserStoreState {
  user: UserInfo | null
}

const INITIAL_USER_STORE: AuthUserStoreState = {
  user: null,
}

const useAuthUserStore = create<AuthUserStoreState>()(
  persist(() => INITIAL_USER_STORE, {
    name: USER_STORE_KEY, // storage key
  }),
)

// Selectors
export const useAuthUser = () =>
  useAuthUserStore((state: AuthUserStoreState) => state.user) as UserInfo

export const isAuthUserAuthenticated = () =>
  useAuthUserStore.getState().user !== null

export const isUserCloudWorker = () =>
  useAuthUserStore.getState().user?.role_name === CLOUD_WORKER_ROLE_NAME

export const useIsUserCloudWorker = () =>
  useAuthUserStore(
    (state: AuthUserStoreState) =>
      state.user?.role_name === CLOUD_WORKER_ROLE_NAME,
  )

export const useIsPlatformAdmin = () =>
  useAuthUserStore((state) => state.user?.isPlatformAdmin === true)

export const getIsPlatformAdmin = () =>
  useAuthUserStore.getState().user?.isPlatformAdmin === true

export const getUserId = () => useAuthUserStore.getState().user?.id ?? null

// Actions
export const setAuthUser = (user: UserInfo) =>
  useAuthUserStore.setState({ user })

export const resetAuthUserStore = () =>
  useAuthUserStore.setState(INITIAL_USER_STORE, true)
